module.exports = __webpack_public_path__ + "static/media/11.3f60ce07.mp3";